import React, { FunctionComponent } from 'react';
import config from 'src/shared/config';
import { Link } from '../buttons';
import { QuestionDialog, useDialogManager } from '../dialog';
import { T } from 'src/shared/helpers';
import { ContanierLanguageMenu, ItemLanguagePopupMenu, PopupMenuItem, TriangleLanguageMenu } from './globalsToolbar';

export interface InfoLanguagePopupMenu {
    isPopupVisible: boolean;
}

const LanguagePopupMenu: FunctionComponent<InfoLanguagePopupMenu> = (props) => {
    const { showDialog, closeDialog } = useDialogManager();

    const intelNav = (newLanguage: string) => {
        const currentUrl = window.location.href;
        const index = currentUrl.indexOf('/' + config.culture);
        const indexSlash = currentUrl.indexOf('/', index + 1);
        const spl = currentUrl.slice(0, index);
        const end = currentUrl.slice(indexSlash, currentUrl.length);
        const newUrl = spl + '/' + newLanguage + end;

        if (newLanguage != 'en-GB' && newLanguage != 'en-US') {
            const msgLanguage = (
                <span>
                    {T._('Please be aware that ', 'Admin')}
                    <strong>{T._('the Zakeke back-office is primarily developed in English, ', 'Admin')}</strong>
                    {T._(
                        'ther languages may rely on automatic translations, which could result in some inaccuracies or unrefined translations. If you would like to modify these ',
                        'Admin'
                    )}
                    <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/articles/4404019251090-Translations'>
                        {T._('translations', 'Admin')}
                    </Link>
                    {T._(', you can do so by navigating to Settings > Translations.', 'Admin')}
                </span>
            );

            showDialog(
                'viewerLanguage',
                <QuestionDialog
                    message={msgLanguage}
                    showCloseButton={false}
                    buttonYesLabel={T._('Ok', 'Admin')}
                    buttonNoLabel={T._('Cancel', 'Admin')}
                    onYesClick={() => {
                        window.location.href = newUrl;
                    }}
                    onNoClick={() => {
                        closeDialog('viewerLanguage');
                    }}
                />
            );
        } else {
            window.location.href = newUrl;
        }
    };

    return (
        <ContanierLanguageMenu $isVisible={props.isPopupVisible}>
            <TriangleLanguageMenu />

            <ItemLanguagePopupMenu>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('af')}>
                    {' '}
                    Afrikaans{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sq')}>
                    {' '}
                    Albanian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('am')}>
                    {' '}
                    Amharic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ar')}>
                    {' '}
                    Arabic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('hy')}>
                    {' '}
                    Armenian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('az')}>
                    {' '}
                    Azeri - Cyrillic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('eu')}>
                    {' '}
                    Basque{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('bn')}>
                    {' '}
                    Bengali{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('bs')}>
                    {' '}
                    Bosnian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('bg')}>
                    {' '}
                    Bulgarian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('my')}>
                    {' '}
                    Burmese{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('zh-CN')}>
                    {' '}
                    Chinese - China{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('zh-TW')}>
                    {' '}
                    Chinese - Taiwan{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('hr')}>
                    {' '}
                    Croatian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('cs')}>
                    {' '}
                    Czech{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('da')}>
                    {' '}
                    Danish{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('de')}>
                    {' '}
                    Deutsch{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('nl')}>
                    {' '}
                    Dutch{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('en-GB')}>
                    {' '}
                    English - United Kingdom{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('en-US')}>
                    {' '}
                    English - United States{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('es-ES')}>
                    {' '}
                    Español{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('et')}>
                    {' '}
                    Estonian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('fa')}>
                    {' '}
                    Farsi - Persian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('fil')}>
                    {' '}
                    Filipino{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('fi')}>
                    {' '}
                    Finnish{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('fr')}>
                    {' '}
                    Français{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('gl')}>
                    {' '}
                    Galician{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ka')}>
                    {' '}
                    Georgian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('el')}>
                    {' '}
                    Greek{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('gu')}>
                    {' '}
                    Gujarati{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ha')}>
                    {' '}
                    Hausa{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('he')}>
                    {' '}
                    Hebrew{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('hi')}>
                    {' '}
                    Hindi{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('hu')}>
                    {' '}
                    Hungarian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('id')}>
                    {' '}
                    Indonesian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('it-IT')}>
                    {' '}
                    Italiano{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ja')}>
                    {' '}
                    Japanese{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('kn')}>
                    {' '}
                    Kannada{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('kk')}>
                    {' '}
                    Kazakh{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('km')}>
                    {' '}
                    Khmer{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ko')}>
                    {' '}
                    Korean{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ky-KG')}>
                    {' '}
                    Kyrgyz - Cyrillic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('lo')}>
                    {' '}
                    Lao{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('lv')}>
                    {' '}
                    Latvian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('lt')}>
                    {' '}
                    Lithuanian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('mk')}>
                    {' '}
                    Macedonia{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ms')}>
                    {' '}
                    Malay{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ml')}>
                    {' '}
                    Malayalam{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('mr')}>
                    {' '}
                    Marathi{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('mn')}>
                    {' '}
                    Mongolian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ne')}>
                    {' '}
                    Nepali{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('nb-NO')}>
                    {' '}
                    Norwegian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('pl')}>
                    {' '}
                    Polskie{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('pt-PT')}>
                    {' '}
                    Português{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('pt-BR')}>
                    {' '}
                    Portuguese - Brazil{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('pa')}>
                    {' '}
                    Punjabi{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ro-MO')}>
                    {' '}
                    Romanian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ru')}>
                    {' '}
                    Russian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sr')}>
                    {' '}
                    Serbian - Cyrillic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sd')}>
                    {' '}
                    Sindhi{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('si')}>
                    {' '}
                    Sinhala{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sk')}>
                    {' '}
                    Slovak{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sl')}>
                    {' '}
                    Slovenian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('so')}>
                    {' '}
                    Somali{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sw')}>
                    {' '}
                    Swahili{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('sv-SE')}>
                    {' '}
                    Swedish{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('tg')}>
                    {' '}
                    Tajik{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ta')}>
                    {' '}
                    Tamil{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('tr')}>
                    {' '}
                    Turkish{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('uk')}>
                    {' '}
                    Ukrainian{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('ur')}>
                    {' '}
                    Urdu{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('uz-UZ')}>
                    {' '}
                    Uzbek - Cyrillic{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('vi')}>
                    {' '}
                    Vietnamese{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('cy')}>
                    {' '}
                    Welsh{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('xh')}>
                    {' '}
                    Xhosa{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('yi')}>
                    {' '}
                    Yiddish{' '}
                </PopupMenuItem>
                <PopupMenuItem $isHeader={false} onClick={() => intelNav('zu')}>
                    {' '}
                    Zulu{' '}
                </PopupMenuItem>
            </ItemLanguagePopupMenu>
        </ContanierLanguageMenu>
    );
};

export default LanguagePopupMenu;
